import { CurrencyCode } from '@/helpers/currency';
import { MediaType } from '@/helpers/enums';
import type { IHeadlinePromoPageConfig } from '@/modules/promotions/templates/HeadlinePromoTemplate/helpers';
import {
  createPromoImg,
  createPromoLevelImages,
  createPromoStage,
} from '@/modules/promotions/templates/HeadlinePromoTemplate/helpers/promoImages';

const LVLS_IMAGE_PATH = '/headline-promo/pumpkin_kingdom';

const getPromoImg = createPromoImg(LVLS_IMAGE_PATH);
const getStage = createPromoStage(LVLS_IMAGE_PATH);
const getLevelImages = createPromoLevelImages(
  LVLS_IMAGE_PATH,
  '138, 56, 245',
  0.4
);

const STAGE_1 = getStage(1);
const STAGE_2 = getStage(2);
const STAGE_3 = getStage(3);
const STAGE_4 = getStage(4);

export const PUMPKIN_KINGDOM_CONFIG: IHeadlinePromoPageConfig = {
  promoKey: 'pumpkin_kingdom',
  route: '/pumpkin-kingdom',
  namespace: 'pumpkinKingdom',
  disableAnimations: true,
  useFullNameAsGroupId: true,
  dateFormat: 'dd.MM',
  hideHowToGamesCountLabel: true,
  progressBarVariant: 'pill',
  hideHowToDescription: false,
  faqBgImage: `${LVLS_IMAGE_PATH}/faq_decor.webp`,
  ctaAlwaysDeposit: true,
  currencyCode: CurrencyCode.EUR,
  levelsMobileBreakpoint: MediaType.MOBILE_S,
  guestIcon: getPromoImg('lvl_10'),

  cardHud: {
    kind: 'image',
    src: `${LVLS_IMAGE_PATH}/hud_default.webp`,
  },

  levelsConfig: [
    {
      name: 'Pumpkin Seed',
      ...getLevelImages(1),
      ...STAGE_1,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 0, 25: 2, 50: 5, 75: 8, 100: 10 },
      reward: { kind: 'freespins', count: 10 },
      rewardGroupKey: 'pumpkin_kingdom_l1_reward',
    },
    {
      name: 'First Sprout',
      ...getLevelImages(2),
      ...STAGE_1,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 10, 25: 14, 50: 18, 75: 21, 100: 25 },
      reward: { kind: 'freespins', count: 20 },
      rewardGroupKey: 'pumpkin_kingdom_l2_reward',
    },
    {
      name: 'Vine Keeper',
      ...getLevelImages(3),
      ...STAGE_1,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 25, 25: 31, 50: 38, 75: 44, 100: 50 },
      reward: { kind: 'freespins', count: 25 },
      rewardGroupKey: 'pumpkin_kingdom_l3_reward',
    },
    {
      name: 'Autumn Field',
      ...getLevelImages(4),
      ...STAGE_1,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 50, 25: 62, 50: 75, 75: 88, 100: 100 },
      reward: { kind: 'freespins', count: 30 },
      rewardGroupKey: 'pumpkin_kingdom_l4_reward',
    },
    {
      name: 'Pumpkin Picker',
      ...getLevelImages(5),
      ...STAGE_2,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 100, 25: 125, 50: 150, 75: 175, 100: 200 },
      reward: { kind: 'freespins', count: 35 },
      rewardGroupKey: 'pumpkin_kingdom_l5_reward',
    },
    {
      name: 'Harvest Rider',
      ...getLevelImages(6),
      ...STAGE_2,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 200, 25: 250, 50: 300, 75: 350, 100: 400 },
      reward: { kind: 'freespins', count: 40 },
      rewardGroupKey: 'pumpkin_kingdom_l6_reward',
    },
    {
      name: 'Prize Grower',
      ...getLevelImages(7),
      ...STAGE_2,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 400, 25: 550, 50: 700, 75: 850, 100: 1000 },
      reward: { kind: 'bonus', amount: 25 },
      rewardGroupKey: 'pumpkin_kingdom_l7_reward',
    },
    {
      name: 'Master Carver',
      ...getLevelImages(8),
      ...STAGE_3,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 1000, 25: 1250, 50: 1500, 75: 1750, 100: 2000 },
      reward: { kind: 'bonus', amount: 50 },
      rewardGroupKey: 'pumpkin_kingdom_l8_reward',
    },
    {
      name: 'Lantern Keeper',
      ...getLevelImages(9),
      ...STAGE_3,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 2000, 25: 2500, 50: 3000, 75: 3500, 100: 4000 },
      reward: { kind: 'bonus', amount: 125 },
      rewardGroupKey: 'pumpkin_kingdom_l9_reward',
    },
    {
      name: 'Pumpkin King',
      ...getLevelImages(10),
      ...STAGE_4,
      promoRewardType: 'bets',
      wagerAmounts: { 0: 4000, 25: 4500, 50: 5000, 75: 5500, 100: 6000 },
      reward: {
        kind: 'bonus',
        amount: 300,
        labelKey: 'missionLevels.card.megaBonus',
        labelOnNewLine: true,
      },
      rewardGroupKey: 'pumpkin_kingdom_l10_reward',
    },
  ],
};
